import React, { useState } from "react";
import { RoleMain } from "./Roles/RoleMain";
import Tab, { TabItem } from "./SettingTabs/Tabs";
import roleIcon from "../../assets/images/tabs/role.png";
import permissionIcon from "../../assets/images/tabs/permission.png";
import delegateAccessIcon from "../../assets/images/tabs/delegate.png";
import managementIcon from "../../assets/images/tabs/management.png";
import appIcon from "../../assets/images/tabs/app.png";
import revertIcon from "../../assets/images/DeathModuleNew/delete.png";
import "./SettingTabs/settingstyle.css";
import { PermissionMain } from "./Permissions/PermissionMain";
import { ManagementMain } from "./Management/ManagementMain";
import RevertDeletionMain from "./RevertDeletion/RevertDeletionMain";
import PlaidCostConfiguration from "./PlaidCost/PlaidCostConfiguration";

export const SettingDashboard = () => {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const onTabSelected = (index) => {
    console.log(index);
    setSelectedIndex(index);
  };

  return (
    <div>
      <div className="profileMain">
        <h1 className="MainProfileHeading">Settings</h1>

        <Tab onTabSelected={onTabSelected}>
          <TabItem>
            <img
              className={`${selectedIndex === 0 ? "imgStyle imgColor" : "imgStyle"}`}
              src={roleIcon}
              alt="Role"
            />
            Role
          </TabItem>
          <TabItem>
            <img className={`${selectedIndex === 1 ? "imgStyle imgColor" : "imgStyle"}`} src={permissionIcon} alt="Permission" />Permission
          </TabItem>
          <TabItem>
            <img className={`${selectedIndex === 2 ? "imgStyle imgColor" : "imgStyle"}`} src={managementIcon} alt="Management" />Management
          </TabItem>
          <TabItem>
            <img className={`${selectedIndex === 3 ? "imgStyle imgColor" : "imgStyle"}`} src={delegateAccessIcon} alt="Delegate Access" />Delegate Access
          </TabItem>
          <TabItem>
            <img className={`${selectedIndex === 4 ? "imgStyle imgColor" : "imgStyle"}`} src={appIcon} alt="App Suite" />App Suite
          </TabItem>
          <TabItem>
            <img className={`${selectedIndex === 5 ? "imgStyle imgColor" : "imgStyle"}`} src={revertIcon} alt="Revert Deletion" />Revert Deletion
          </TabItem>
          <TabItem>
            <img className={`${selectedIndex === 6 ? "imgStyle imgColor" : "imgStyle"}`} src={appIcon} alt="Plaid Cost" />Plaid Cost
          </TabItem>
        </Tab>

        {selectedIndex === 0 && <RoleMain />}
        {selectedIndex === 1 && <PermissionMain index={1} />}
        {selectedIndex === 2 && <ManagementMain />}
        {selectedIndex === 5 && <RevertDeletionMain />}
        {selectedIndex === 6 && <PlaidCostConfiguration />}
      </div>
    </div>
  );
};

